import React from 'react';

export default function ListIcon({ className = '', title }) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M1.5 15C2.32843 15 3 15.6716 3 16.5C3 17.3284 2.32843 18 1.5 18C0.671573 18 0 17.3284 0 16.5C0 15.6716 0.671573 15 1.5 15ZM18 17.25H4.5V15.75H18V17.25ZM1.5 7.5C2.32843 7.5 3 8.17157 3 9C3 9.82843 2.32843 10.5 1.5 10.5C0.671573 10.5 0 9.82843 0 9C0 8.17157 0.671573 7.5 1.5 7.5ZM15 9.75H4.5V8.25H15V9.75ZM1.5 0C2.32843 0 3 0.671573 3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0ZM18 2.25H4.5V0.75H18V2.25Z"
        fill="currentColor"
      />
    </svg>

  );
}

